import { ParamMap } from "@angular/router";
import { Criteria } from "./criteria/criteria";

export class SearchRequest {
  public query = "";
  private criteriasValues = new Map<string, string[]>()

  constructor(private criterias: Map<string, Criteria>) {
    for (let criteria of criterias.keys()) {
      this.criteriasValues.set(criteria, []);
    }
  }

  public addFilter(criteriaKey: string, value: string) {
    for (let existingValue of this.getValues(criteriaKey)) {
      if (existingValue == value) {
        return;
      }
    }

    this.criteriasValues.get(criteriaKey)?.push(value);
  }

  private clearAll() {
    this.query = "";
    for (const criteria of this.criteriasValues.keys()) {
      this.clearFilter(criteria);
    }
  }

  public clearFilter(criteria: string) {
    this.criteriasValues.set(criteria, []);
  }

  public displayCriteriaValues(criteriaKey: string): string {
    let criteria = this.getCriteria(criteriaKey);

    let values = this.getValues(criteriaKey);

    return criteria.displayValues(values);
  }

  public getQueryParams(): any {
    var queryParams: any = { query: this.query };
    for (let [criteria, values] of this.criteriasValues) {
      queryParams[criteria] = values;
    }

    return queryParams;
  }

  public getValues(criteriaKey: string): string[] {
    let values = this.criteriasValues.get(criteriaKey);
    if (values == undefined) {
      throw new Error("criteria " + criteriaKey + " does not exists in search request");
    }

    return values;
  }

  private getCriteria(key: string): Criteria {
    let criteria = this.criterias.get(key);
    if (criteria == undefined) {
      throw new Error("criteria " + key + " does not exists in search request");
    }

    return criteria;
  }

  public initWithParamMap(paramMap: ParamMap) {
    this.clearAll();
    this.query = paramMap.get("query") || "";
    for (const [criteria, _] of this.criterias) {
      this.criteriasValues.set(criteria, paramMap.getAll(criteria));
    }
  }
}